import { Component, OnInit, AfterContentInit, AfterViewInit, OnDestroy, Input, ViewChild, ContentChild, OnChanges, SimpleChange, ContentChildren, ChangeDetectionStrategy, Output, EventEmitter, QueryList, TemplateRef, ViewChildren, Renderer2, NgZone, ChangeDetectorRef } from '@angular/core';

import { Subscription } from 'rxjs/Subscription';

import { TabToggleDirective } from './tabs.directive';
export class TabHeaderComponent {
public templateRef: TemplateRef<any>;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mk-tab-header',
  template: '<ng-template #templateRef><ng-content></ng-content></ng-template>',
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'templateRef': [{ type: ViewChild, args: ['templateRef', ] },],
};
}

function TabHeaderComponent_tsickle_Closure_declarations() {
/** @type {?} */
TabHeaderComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TabHeaderComponent.ctorParameters;
/** @type {?} */
TabHeaderComponent.propDecorators;
/** @type {?} */
TabHeaderComponent.prototype.templateRef;
}

export class TabContentComponent {
public templateRef: TemplateRef<any>;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mk-tab-content',
  template: '<ng-template #templateRef><ng-content></ng-content></ng-template>',
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'templateRef': [{ type: ViewChild, args: ['templateRef', ] },],
};
}

function TabContentComponent_tsickle_Closure_declarations() {
/** @type {?} */
TabContentComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TabContentComponent.ctorParameters;
/** @type {?} */
TabContentComponent.propDecorators;
/** @type {?} */
TabContentComponent.prototype.templateRef;
}

export class TabComponent implements OnInit {
public index: number;
public isActive = false;
private contentTemplateRef: TemplateRef<any>;
public header: string;
public isDisabled: boolean;
public tabColor: string;
public templateRef: TemplateRef<any>;
public tabHeaderComponent: TabHeaderComponent;
public tabContentComponent: TabContentComponent;
/**
 * \@method ngOnInit
 * @return {?}
 */
ngOnInit() {
    if(this.tabContentComponent) {
      this.contentTemplateRef = this.tabContentComponent.templateRef;
    } else {
      this.contentTemplateRef = this.templateRef;
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mk-tab',
  template: '<ng-template #templateRef><ng-content></ng-content></ng-template>',
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'header': [{ type: Input },],
'isDisabled': [{ type: Input },],
'tabColor': [{ type: Input },],
'templateRef': [{ type: ViewChild, args: ['templateRef', ] },],
'tabHeaderComponent': [{ type: ContentChild, args: [TabHeaderComponent, ] },],
'tabContentComponent': [{ type: ContentChild, args: [TabContentComponent, ] },],
};
}

function TabComponent_tsickle_Closure_declarations() {
/** @type {?} */
TabComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TabComponent.ctorParameters;
/** @type {?} */
TabComponent.propDecorators;
/** @type {?} */
TabComponent.prototype.index;
/** @type {?} */
TabComponent.prototype.isActive;
/** @type {?} */
TabComponent.prototype.contentTemplateRef;
/** @type {?} */
TabComponent.prototype.header;
/** @type {?} */
TabComponent.prototype.isDisabled;
/** @type {?} */
TabComponent.prototype.tabColor;
/** @type {?} */
TabComponent.prototype.templateRef;
/** @type {?} */
TabComponent.prototype.tabHeaderComponent;
/** @type {?} */
TabComponent.prototype.tabContentComponent;
}

export class TabsHeaderComponent {
public templateRef: TemplateRef<any>;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mk-tabs-header',
  template: '<ng-template #templateRef><ng-content></ng-content></ng-template>',
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'templateRef': [{ type: ViewChild, args: ['templateRef', ] },],
};
}

function TabsHeaderComponent_tsickle_Closure_declarations() {
/** @type {?} */
TabsHeaderComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TabsHeaderComponent.ctorParameters;
/** @type {?} */
TabsHeaderComponent.propDecorators;
/** @type {?} */
TabsHeaderComponent.prototype.templateRef;
}

export class TabsComponent implements AfterContentInit, AfterViewInit, OnChanges {
private activatedTabIndex: number;
private toggleListeners: Array<Function> = [];
private subscription: Subscription;
/**
 * @param {?} index
 * @return {?}
 */
public set activeTabIndex(index: number) {
    this.activatedTabIndex = index;
    this.changeDetectorRef.detectChanges();
  }
/**
 * @return {?}
 */
public get activeTabIndex(): number {
    return this.activatedTabIndex;
  }
public header: string;
public headerStyleClass = 'header pull-left';
public navStyleClass = 'nav nav-tabs';
public contentStyleClass = 'tab-content';
public styleClass = 'nav-tabs-custom';
public tabsColor: string;
public onClose = new EventEmitter();
public onOpen = new EventEmitter();
public tabsHeaderComponent: TabsHeaderComponent;
public tabs: QueryList<TabComponent>;
public tabToggleDirectives: QueryList<TabToggleDirective>;
/**
 * \@method constructor
 * @param {?} changeDetectorRef
 * @param {?} ngZone
 * @param {?} renderer2
 */
constructor(
private changeDetectorRef: ChangeDetectorRef,
private ngZone: NgZone,
private renderer2: Renderer2
  ) {}
/**
 * \@method ngAfterViewInit
 * @return {?}
 */
ngAfterContentInit() {
    // Set tab index on load.
    this.setTabIndex();

    // Update tab index if tabs is updated.
    this.subscription = this.tabs.changes.subscribe(changes => {
      this.setTabIndex();
    });

    // Open tab on load.
    this.openTabIndex();
  }
/**
 * \@method ngAfterViewInit
 * @return {?}
 */
ngAfterViewInit() {
    // Set tab toggles on load.
    this.setTabsToggle();

    // Update tab toggles if tabs is updated.
    this.tabToggleDirectives.changes.subscribe(changes => {
      this.setTabsToggle();
    });
  }
/**
 * \@method ngOnChanges
 * @param {?} changes
 * @return {?}
 */
ngOnChanges(changes: {[propKey: string]: SimpleChange}) {
    if(changes.activeTabIndex) {
      this.openTabIndex();
    }
  }
/**
 * \@method ngOnDestroy
 * @return {?}
 */
ngOnDestroy() {
    this.removeListeners();
    this.subscription.unsubscribe();
  }
/**
 * [toggleTab description]
 * \@method toggleTab
 * @return {?}
 */
public openTabIndex(): void {
    if(this.tabs) {
      this.tabs.forEach((tab: TabComponent) => {
        if(this.activatedTabIndex === tab.index || tab.index === 0 && typeof this.activatedTabIndex !== 'number') {
          tab.isActive = true;
          this.onOpen.emit({index: tab.index});
          this.changeDetectorRef.detectChanges();
        } else if(tab.isActive) {
          tab.isActive = false;
          this.onClose.emit({index: tab.index});
          this.changeDetectorRef.detectChanges();
        }
      });
    }
  }
/**
 * [openTab description]
 * \@method openTab
 * @param {?} event
 * @param {?} tabToOpen
 * @return {?}
 */
public openTab(event: Event, tabToOpen: TabComponent): void {
    event.preventDefault();
    tabToOpen.isActive = true;
    this.onOpen.emit({event, index: tabToOpen.index});
    this.tabs.forEach((tab: TabComponent) => {
      if(tab.isActive && tabToOpen !== tab) {
        tab.isActive = false;
        this.onClose.emit({event, index: tab.index});
      }
    });
  }
/**
 * [setTabIndex description]
 * \@method setTabIndex
 * @return {?}
 */
private setTabIndex(): void {
    this.tabs.forEach((tab: TabComponent, index: number) => {
      tab.index = index;
    });
    this.changeDetectorRef.detectChanges();
  }
/**
 * [setTabsToggle description]
 * \@method setTabsToggle
 * @return {?}
 */
private setTabsToggle(): void {
    this.removeListeners();
    this.ngZone.runOutsideAngular(() => {
      this.tabToggleDirectives.forEach((tabToggle: TabToggleDirective) => {
        this.toggleListeners.push(this.renderer2.listen(tabToggle.elementRef.nativeElement, 'click', (event) => {
          this.openTab(event, tabToggle.tabComponent);
          this.changeDetectorRef.detectChanges();
        }));
      });
    });
  }
/**
 * [removeListeners description]
 * \@method removeListeners
 * @return {?}
 */
private removeListeners(): void {
    if(this.toggleListeners) {
      this.toggleListeners.forEach((listener: Function) => {
        listener();
      });
    }
    this.toggleListeners = [];
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mk-tabs',
  template: `
    <div [ngClass]="styleClass">
      <ul [ngClass]="navStyleClass" [class.pull-right]="header || tabsHeaderComponent">
        <li *ngFor="let tab of tabs" [class.active]="tab.isActive" [mkColor]="tab.tabColor || tabsColor" mkColorProperty="border-top-color">
          <a *ngIf="!tab.isDisabled" [mkTabToggle]="tab" href="#">
            {{tab.header}}
            <ng-template *ngIf="!tab.header" [ngTemplateOutlet]="tab.tabHeaderComponent?.templateRef"></ng-template>
          </a>
          <ng-template [ngIf]="tab.isDisabled">
            {{tab.header}}
            <ng-template *ngIf="!tab.header" [ngTemplateOutlet]="tab.tabHeaderComponent.templateRef"></ng-template>
          </ng-template>
        </li>
        <li *ngIf="tabsHeaderComponent || header" [ngClass]="headerStyleClass">
          {{header}}
          <ng-template *ngIf="!header" [ngTemplateOutlet]="tabsHeaderComponent.templateRef"></ng-template>
        </li>
      </ul>
      <div [ngClass]="contentStyleClass">
        <div *ngFor="let tab of tabs" class="tab-pane" [class.active]="tab.isActive">
          <ng-template [ngTemplateOutlet]="tab.contentTemplateRef"></ng-template>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .nav-tabs-custom > .nav-tabs > li {
      border-top-width: 0;
    }

    .nav-tabs-custom > .nav-tabs > li.active {
      border-top-width: 3px;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ChangeDetectorRef, },
{type: NgZone, },
{type: Renderer2, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'activeTabIndex': [{ type: Input },],
'header': [{ type: Input },],
'headerStyleClass': [{ type: Input },],
'navStyleClass': [{ type: Input },],
'contentStyleClass': [{ type: Input },],
'styleClass': [{ type: Input },],
'tabsColor': [{ type: Input },],
'onClose': [{ type: Output },],
'onOpen': [{ type: Output },],
'tabsHeaderComponent': [{ type: ContentChild, args: [TabsHeaderComponent, ] },],
'tabs': [{ type: ContentChildren, args: [TabComponent, ] },],
'tabToggleDirectives': [{ type: ViewChildren, args: [TabToggleDirective, ] },],
};
}

function TabsComponent_tsickle_Closure_declarations() {
/** @type {?} */
TabsComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TabsComponent.ctorParameters;
/** @type {?} */
TabsComponent.propDecorators;
/** @type {?} */
TabsComponent.prototype.activatedTabIndex;
/** @type {?} */
TabsComponent.prototype.toggleListeners;
/** @type {?} */
TabsComponent.prototype.subscription;
/** @type {?} */
TabsComponent.prototype.header;
/** @type {?} */
TabsComponent.prototype.headerStyleClass;
/** @type {?} */
TabsComponent.prototype.navStyleClass;
/** @type {?} */
TabsComponent.prototype.contentStyleClass;
/** @type {?} */
TabsComponent.prototype.styleClass;
/** @type {?} */
TabsComponent.prototype.tabsColor;
/** @type {?} */
TabsComponent.prototype.onClose;
/** @type {?} */
TabsComponent.prototype.onOpen;
/** @type {?} */
TabsComponent.prototype.tabsHeaderComponent;
/** @type {?} */
TabsComponent.prototype.tabs;
/** @type {?} */
TabsComponent.prototype.tabToggleDirectives;
/** @type {?} */
TabsComponent.prototype.changeDetectorRef;
/** @type {?} */
TabsComponent.prototype.ngZone;
/** @type {?} */
TabsComponent.prototype.renderer2;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
